let ctx = null;

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(freq, start, dur, type = "sine", gain = 0.16) {
  const c = ac();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime + start);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + start + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(c.currentTime + start);
  o.stop(c.currentTime + start + dur + 0.05);
}

export function playNewOrder(enabled) {
  if (!enabled) return;
  try {
    tone(880, 0, 0.18, "sine", 0.14);
    tone(1174, 0.16, 0.24, "sine", 0.14);
  } catch (e) { /* audio bloqueado */ }
}

export function playCashAlert(enabled) {
  if (!enabled) return;
  try {
    tone(523, 0, 0.16, "square", 0.10);
    tone(659, 0.18, 0.16, "square", 0.10);
    tone(784, 0.36, 0.28, "square", 0.12);
  } catch (e) { /* audio bloqueado */ }
}

export function playSoftTick(enabled) {
  if (!enabled) return;
  try { tone(660, 0, 0.09, "sine", 0.08); } catch (e) { /* noop */ }
}
